<template>
  <div>
    <!-- <hero-banner :title="title"></hero-banner> -->
      <nav class="d-none d-md-block " aria-label="breadcrumb" >
            <ol class="breadcrumb breadcrumb-arrow">
                <li class="breadcrumb-item">
                <router-link to="/" style="color:#666666">Home</router-link>
              </li>
              
                <li class="breadcrumb-item active">{{title}}</li>
            </ol>
        </nav>

    <div class="my-5 container">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="terms-list">
            <div class="mb-5">
              <h5>Corporate Social Responsibility (CSR)</h5>
              <p>
               Corporate Social responsibility is a key component of our overarching goal to positively impact society. To ensure optimum impact and sustainability, our CSR strategy focuses on four major pillars:
              </p>
              <ul style="padding-left:0.3rem">
                <li>	Community Development & Social Welfare</li>
                  <li>Skills Training</li>
                    <li>Education</li>
                     <li>Sports</li>

                   
              </ul>
              <p>We are committed to creating enduring partnerships and adding immense value to the diverse communities around us.</p>
             
            </div>
              <div class="careerimg mb-5"></div>
           

          </div>
        </div>
      </div>
    </div>
     <div class="bg-dark" style="padding-top:3rem">
      <div class="container">
        <core style="border-top:1px solid rgba(255, 255, 255, .24)"></core>
      </div>
    </div>
  </div>
</template>

<script>
// import TopHeroBanner from "@/components/TopHeroBanner1.vue";
import CoreValues from "../components/Core.vue";
export default {
  components: { core: CoreValues },
  name: "csr",
  data() {
    return {
      title: "CSR"
    };
  },
  metaInfo() {
    return {
      title: "CSR"
    };
  }
};
</script>
